export default "__VITE_ASSET__CRZODq63__"